import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CategoryController } from "../controllers/CategoryController.js";
import "../styles/Footer.css";

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    CategoryController.list()
      .then(setCategories)
      .catch((err) => console.error("Failed to load categories", err));
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content row">
          <div className="footer-about col-md-12 col-lg-4">
            <img src="https://meastreport.com/cms/wp-content/uploads/2025/09/logo-middle-east-report.png" alt="Logo de Middle East Report" className="img-fluid w-75 mb-3" />
            <h3 className="d-none">Middle East Report</h3>
            <p>
              Middle East Report selects, analyzes and synthesizes the most
              relevant information on Middle East, allowing the reader to obtain
              an overview of what is happening in the region in a few minutes of
              reading.
            </p>
            <hr className="d-block d-sm-block d-md-block d-lg-none"/>
          </div>
          <div className="footer-links col-md-6 col-lg-4">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/countries" onClick={() => window.scrollTo(0, 0)}>Countries</Link>
              </li>
              <li>
                <Link to="/about" onClick={() => window.scrollTo(0, 0)}>About</Link>
              </li>
            </ul>
            <hr className="d-block d-lg-none d-md-none"/>
          </div>
          <div className="footer-categories col-md-6 col-lg-4">
            <h4>Categories</h4>
            <ul>
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} onClick={() => window.scrollTo(0, 0)}>{cat.name}</Link>
                </li>
              ))}
            </ul>
            <hr className="d-block d-lg-none d-md-none"/>
          </div>
          <hr className="d-none d-md-block d-lg-none d-sm-none"/>
          <div className="footer-contact col-md-6 col-lg-3 d-none">
            <h4>Contact</h4>
            <p>Email: info@meastreport.com</p>
            <div className="social-icons">
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Middle East Report</p>
      </div>
    </footer>
  );
};

export default Footer;